import React, { useCallback } from 'react';
import Select from 'react-select';

import { getFlexSelectCustomStyle } from '../../assets/styles/multiple_select';
import { useMemorizeFilters } from '../../hooks/useMemorizeInputsFilters';

const width = '5rem';
const POSSIBLE_SELECT_OPTIONS = [10, 20, 50, 100];

export const ItemPerPageSelect = ({ valueController, entity }) => {
  const { getMemorizedFilters, memorizeFilters } = useMemorizeFilters(entity);

  const getDefaultValue = useCallback(() => {
    const memorizedFilters = getMemorizedFilters() || {};
    if (
      memorizedFilters.size &&
      POSSIBLE_SELECT_OPTIONS.includes(memorizedFilters.size)
    ) {
      return {
        label: memorizedFilters.size,
        value: memorizedFilters.size
      };
    }
    return { label: 10, value: 10 };
  }, [getMemorizedFilters]);

  const handleChange = useCallback(
    (selectedOption) => {
      const memorizedFilters = getMemorizedFilters() || {};
      valueController(selectedOption.value);
      memorizeFilters({ ...memorizedFilters, size: selectedOption.value });
    },
    [valueController]
  );

  return (
    <Select
      styles={getFlexSelectCustomStyle({ width })}
      classNamePrefix="react-select"
      placeholder="Selecione..."
      defaultValue={getDefaultValue()}
      closeMenuOnSelect={true}
      noOptionsMessage={() => 'Nenhuma opção'}
      onChange={handleChange}
      options={POSSIBLE_SELECT_OPTIONS.map((option) => ({
        label: option,
        value: option
      }))}
    />
  );
};
